var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFormatSubscriptIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#006C8E",
  d: "M19 21v-2c0-.283.096-.52.288-.712A.968.968 0 0 1 20 18h2v-1h-3v-1h3c.283 0 .52.096.712.288A.965.965 0 0 1 23 17v1c0 .283-.096.52-.288.712A.968.968 0 0 1 22 19h-2v1h3v1h-4zM5.875 19l4.625-7.275L6.2 5h2.65l3.1 5h.1l3.075-5H17.8l-4.325 6.725L18.125 19H15.45l-3.4-5.425h-.1L8.55 19H5.875z"
}))));
export default SvgFormatSubscriptIcon;